const yup = require("yup");

// Schema for createcollegerules
const creatSubPageGroup = yup.object({
  pagegroup: yup.string().required("Page group is required"),
  name: yup.string().required("Name is required"),
});

module.exports = {
  creatSubPageGroup,
};
